(function (angular) {
	'use strict';

	angular.module('cancelTransactionModalModule', [
		'apiModule',
		'coreModule',
		'formValidationModule'
	]);
})(window.angular);
